<div
  class="modal-container row-gap-0"
  [ngClass]="{ 'backdrop-removed': !modalContent.hasBackdrop }"
>
  <div
    class="modal-header grid-container col-auto col-gap-0 row-gap-0 pl-1 pr-1 pt-1"
    *ngIf="showModalHeaderSection"
    [ngClass]="{
      'mb-1': modalContent.title,
      'titleless-modal-header': !modalContent.title,
    }"
  >
    <div
      class="modal-header-icon grid-container grid-items-align-vertical-center grid-container-content-horizontal-center"
      *ngIf="modalContent.headerIcon && modalContent.headerIcon.icon"
      [ngClass]="[modalContent.headerIcon.iconType]"
    >
      <mat-icon
        [svgIcon]="modalContent.headerIcon.icon"
        class="icon"
        [ngClass]="[modalContent.headerIcon.iconType + '-lidskjalv-no-access']"
      ></mat-icon>
    </div>
    <div
      [ngClass]="{
        'grid-item-self-justify-right': !modalContent.headerIcon,
        'grid-item-self-justify-center': modalContent.headerIcon
      }"
    >
      <span class="modal-header-title font-weight-bold">
        {{ modalContent.title }}
      </span>
    </div>
    <div class="close-btn-container grid-item-self-justify-right">
      <button
        class="close-button grid-container"
        [ngClass]="{
          'no-background-close-button': modalContent.noBackgroundCloseButton
        }"
        (click)="this.modalService.close()"
        *ngIf="!modalContent.hideCloseButton"
      >
        <mat-icon
          svgIcon="close-x"
          class="icon modal-close-button-icon xs grid-item-self-justify-center grid-item-self-align-center"
        ></mat-icon>
      </button>
    </div>
  </div>
  <div
    class="modal-content row-gap-0 col-gap-0 mr-1 ml-1 mb-0_5"
    [ngClass]="{
      'mt-1': modalContent.title
    }"
  >
    <ng-container
      *ngComponentOutlet="modalContent.template; inputs: modalContent.input"
    ></ng-container>
  </div>
  <div
    class="modal-footer grid-container row-gap-0 col-gap-0 pb-1 pt-1"
    [ngClass]="{ 'hide-top-border mt-0_5': modalContent.hideFooterDevider }"
  >
    <ng-template [ngTemplateOutlet]="footerActionsTemplate"></ng-template>
  </div>
</div>
